import { render, staticRenderFns } from "./AddEditEmbedPopup.vue?vue&type=template&id=00b7bf7c&scoped=true&"
import script from "./AddEditEmbedPopup.vue?vue&type=script&lang=js&"
export * from "./AddEditEmbedPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddEditEmbedPopup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddEditEmbedPopup.vue?vue&type=style&index=1&id=00b7bf7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7bf7c",
  null
  
)

export default component.exports